import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { mapParamsBySchema } from '../../../../util';
import { PPE_BASIC_04_Schema } from './PPE_BASIC_04_Schema';

/**
 * PPE_BASIC_04(보호구 기록) 관련 React Query 훅 모음
 */

// 보호구 기록 조회
export const useSearch1 = (options = {}) => {
  const { onSuccess, context } = options;

  // queryKey에 context 정보 포함 (동적으로 업데이트됨)
  const queryKey = [
    'PPEManagement',
    'getPpeBasic04R1',
    context?.search?.depCd || '',
    context?.search?.equipDate || context?.search?.searchDate || '',
    context?.search?.params || context?.search?.searchText || '',
  ];

  const query = useQuery({
    queryKey,
    queryFn: () => {
      // queryFn 내에서 최신 context로 params 생성
      const params = mapParamsBySchema(
        PPE_BASIC_04_Schema.mapper.search1,
        context
      );
      return apiRequest(
        'post',
        Global.urls.PPEManagement.getPpeBasic04R1,
        params
      );
    },
    enabled: false, // 자동 실행 방지
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt, query.data]);

  return query;
};

